import { render, staticRenderFns } from "./related-orders-table.vue?vue&type=template&id=a1c5a3c8"
import script from "./related-orders-table.vue?vue&type=script&lang=js"
export * from "./related-orders-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports